import { render, staticRenderFns } from "./UiUshersForm.vue?vue&type=template&id=60cf919c&lang=pug&"
import script from "./UiUshersForm.vue?vue&type=script&lang=js&"
export * from "./UiUshersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports